/* @flow */
import React from 'react'
import { Provider } from 'react-redux'
import { Route } from 'react-router'
import { ConnectedRouter, routerMiddleware } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'

import './App.css'
import configureStore from './configs/configureStore'
import Wrapper from './containers/Wrapper'
import Home from './containers/Home'
import Account from './containers/Account'
import Search from './containers/Search'
import MapMode from './containers/MapMode'
import Shop from './containers/Shop'
import Activity from './containers/Activity'
import Order from './containers/Order'
import OrderConfirm from './containers/OrderConfirm'
import AccountOrder from './containers/AccountOrder'
import Terms from './containers/Terms'
import Privacy from './containers/Privacy'
import { createMuiTheme } from '@material-ui/core';
import { lightBlue, teal, blue } from '@material-ui/core/colors';

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory()
// Build the middleware for intercepting and dispatching navigation actions
const historyMiddleware = routerMiddleware(history)
const store = configureStore(undefined, historyMiddleware)

const theme = createMuiTheme({
  palette: {
    primary: {
      light: lightBlue[700],
      main: '#006699',
      dark: blue[900],
    },
    secondary: {
      main: '#009999',
    },
  }
})

const App = () => (
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      { /* ConnectedRouter will use the store from Provider automatically */ }
      <Wrapper>
        <ConnectedRouter history={history}>
          <div>
            <Route path="/" exact component={Home} />
            <Route path="/account" component={Account} />
            <Route path="/search" component={Search} />
            <Route path="/map" component={MapMode} />
            <Route path="/shop/:shopId" component={Shop} />
            <Route path="/activity/:activityId" component={Activity} />
            <Route path="/order" component={Order} />
            <Route path="/orders/:orderNo" component={AccountOrder} />
            <Route path="/orderConfirm/:orderNo" component={OrderConfirm} />
            <Route path="/orderCancel/:orderNo" component={OrderConfirm} />
            <Route path="/terms" component={Terms} />
            <Route path="/privacy" component={Privacy} />
          </div>
        </ConnectedRouter>
      </Wrapper>
    </MuiThemeProvider>
  </Provider>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js